import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "./SimplePresentationRunner";
import {FlightMode} from "../FlightMode";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {FlightModeSound} from "../misc/FlightModeSound";

export class BrokeBankPresentation implements SimplePresentation {

    name:string = "BrokeBankPresentation";

    shouldRun():boolean {
        return FlightMode.model.brokeTheBank;
    }

    start(controller:SimplePresentationRunnerController):void {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            controller.setSkipCallback();
            FlightMode.keypadPlugin.setZeroBetSpinCounter(-1);
            FlightMode.soundPlayer.fadeOutMusic();
            FlightMode.updateKeypadWin();
            FlightMode.soundPlayer.playSound("maxWinIntro");
        })

        tl.add(FlightMode.transitionScreen.maxWin.show());
        tl.add(() => {
            FlightMode.soundPlayer.playLoopingSound("winCapLoop");
            FlightMode.transitionScreen.enableButton(() => {
                FlightMode.soundPlayer.switchMusic(FlightModeSound.BASE_GAME_MUSIC);
                FlightMode.soundPlayer.fadeInMusic();
                FlightMode.soundPlayer.stopSound("winCapLoop");
                FlightMode.backgroundElements.setToBaseGame();
                FlightMode.transitionScreen.maxWin.hide();
                controller.finish();
            }, "maxWinContinueButtonBackToMain");
        }, '<1.3')
     }
}